<template>
  <data-list
    ref="dataList"
    class="content"
    add-btn="添加"
    name="角色"
    hide-audit
    show-row-num
    :url="url"
    :query="query"
    :rules="rules"
    :action-width="200"
    :modal-width="480"
    :modal-form="modalForm"
    :search-key-type="{name: 1}"
    :columns="columns"
    :before-edit="beforeEdit"
    :before-update="beforeUpdate">
    <template v-slot:query="{form}">
      <a-form-model-item label="">
        <a-input-search v-model="form.keyword" placeholder="输入角色名称查询" @search="getList"></a-input-search>
      </a-form-model-item>
    </template>
    <template v-slot:edit="{form}">
      <a-form-model-item label="角色名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入角色名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="模块权限" prop="modules">
        <module-setting v-model="form.modules"></module-setting>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>

    import {getModuleNames} from "../permission/module";

    export default {
        name: "Role",
        data() {
            return {
                url: "/admin/role",
                query: "&sort=sort&expand=num",
                rules: {
                    name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
                    modules: [{ required: true, message: '请选择模块权限', trigger: 'change' }],
                },
                columns: [
                    { title: '角色名称', dataIndex: 'name' },
                    { title: '模块权限', dataIndex: 'modules', customRender: text => getModuleNames(text) },
                    { title: '关联人数', dataIndex: 'num' },
                ],
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                }
            }
        },
        methods: {
            beforeUpdate(form, fn) {
                const data = {
                    name: form.name,
                    modules: form.modules && form.modules.length > 0 ? form.modules.join(",") : null
                };
                if (form.id) {
                    data.id = form.id;
                }
                fn(data);
            },
            beforeEdit(form, fn) {
                form.modules = form.modules ? form.modules.split(",") : [];
                fn();
            },
            getList() {
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped>

</style>
